module.exports = __webpack_public_path__ + "img/Recycle.77a8078f.png";